"use client";

import { useEffect, useState } from "react";
import { cn } from "@/lib/utils";
import { useTranslations } from "next-intl";

const RESEND_TIME = 120;

export default function ResendTimer({
  onResend,
  isError,
}: {
  onResend: () => void;
  isError: boolean;
}) {
  const t = useTranslations("auth");
  const [timeLeft, setTimeLeft] = useState(RESEND_TIME);

  useEffect(() => {
    if (timeLeft <= 0) {
      return;
    }
    if (isError) {
      setTimeLeft(RESEND_TIME);
      return;
    }

    const timer = setInterval(() => {
      setTimeLeft((prev) => prev - 1);
    }, 1000);

    return () => clearInterval(timer);
  }, [timeLeft, isError]);

  const handleResend = () => {
    onResend();
    setTimeLeft(RESEND_TIME);
  };

  return (
    <div className={cn("text-end text-xs text-gray-700 sm:text-sm")}>
      {isError || timeLeft <= 0 ? (
        <button
          onClick={handleResend}
          className="text-primary-main hover:text-secondary-main cursor-pointer"
        >
          ارسال مجدد کد
        </button>
      ) : (
        <>
          {t("timeLeft")} {String(Math.floor(timeLeft / 60)).padStart(2, "0")}:
          {String(timeLeft % 60).padStart(2, "0")}
        </>
      )}
    </div>
  );
}
